var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trailing-icon",
    clipPath: "url(#phoneIcon)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.0769 4H8.92308C7.86154 4 7 4.81455 7 5.81818V18.1818C7 19.1855 7.86154 20 8.92308 20H15.0769C16.1385 20 17 19.1855 17 18.1818V5.81818C17 4.81455 16.1385 4 15.0769 4ZM12 19.2727C11.3615 19.2727 10.8462 18.7855 10.8462 18.1818C10.8462 17.5782 11.3615 17.0909 12 17.0909C12.6385 17.0909 13.1538 17.5782 13.1538 18.1818C13.1538 18.7855 12.6385 19.2727 12 19.2727ZM15.4615 16.3636H8.53846V6.18182H15.4615V16.3636Z",
    fill: "#295BB7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "phoneIcon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.698451a0a7a24c455f1921f4853f687e.svg";
export { ForwardRef as ReactComponent };